import { Injectable } from '@angular/core';
import { loadScript, PayPalNamespace } from '@paypal/paypal-js';
import { environment } from '../../../environments/environment';
import { PaypalCreateOrderResponse } from '../../types/responses';
import { CoreModule } from '../core.module';
import { ServerConnectionService } from './server-connection.service';

@Injectable({
	providedIn: CoreModule,
})
export class PaypalService {
	private paypal: PayPalNamespace | null = null;

	constructor(public serverConnectionService: ServerConnectionService) { }

	public async getInstance() {
		if (!this.paypal) {
			const paypalClientId = environment.payPalClientId;
			this.paypal = await loadScript({ clientId: paypalClientId, disableFunding: ['credit', 'card'] });
		}
		return this.paypal;
	}

	/**
	 * Creates a paypal order for approval.
	 */
	public createOrder() {
		return this.serverConnectionService.post$<PaypalCreateOrderResponse>('/api/paypal/orders', {});
	}
}
